import React from 'react';
import WaitingAreaPage from '../../../../containers/WaitingAreaPage';
import MeetingRoomCallPage from '../../../../containers/MeetingRoomCallPage';
import { redirectToInternalLink } from '../../../../businessLogic/redirector';
import { updateShowQuickViewModal, updateHideWhenClickAwayQuickView } from '../../../../actions/modal';
import { Button, Icon } from 'semantic-ui-react';

const ViewQuickViewCenterPanel = (props) => {
  /* 
  * unused methods
  const goToGroups = () => {
    let show = false;
    props.dispatch(updateShowQuickViewModal(show));
    redirectToInternalLink('groups/view-all');
  };
  const openQuickViewHelp = () => {
    window.open(APP.EXTERNAL_LINKS.Login.ForgotPassword, '_blank');
  }
  */

  const goToOrg = () => {
    let show = false;
    props.dispatch(updateShowQuickViewModal(show));
    redirectToInternalLink('/organisational-unit/view-all');
    props.loggedInUserHandler();
  };

  const goToWaitingAreas = () => {
    let show = false;
    props.dispatch(updateShowQuickViewModal(show));
    if (props.waitingAreas) {
      if (props.waitingAreas.length == 1) {
        redirectToInternalLink(`waiting-area/view-one/${props.waitingAreas[0].id}`);
      } else {
        redirectToInternalLink('waiting-area/view-all');
      }
    }
    props.loggedInUserHandler();
  };
  const goToMeetingRooms = () => {
    let show = false;
    props.dispatch(updateShowQuickViewModal(show));
    redirectToInternalLink('meeting-room/view-all');
    props.loggedInUserHandler();
  };
  const goToReports = () => {
    let show = false;
    props.dispatch(updateShowQuickViewModal(show));
    redirectToInternalLink('report');
    props.loggedInUserHandler();
  };
  const goToResourceCentre = () => {
    window.open('/resourcecentre', 'mgt-console-help');
  };

  const goToUsers = () => {
    let show = false;
    props.dispatch(updateShowQuickViewModal(show));
    redirectToInternalLink('user/view-all');
    props.loggedInUserHandler();
  };

  return (
    <div className={props.isSingleColumn ? '' : 'display-flex flex-wrap'}>
      {props.userHasWaitingAreas ? (
        <div className="pdlxxs pdrxxs quick-view-tile mrbxs">
          <Button
            icon
            labelPosition="right"
            onClick={goToWaitingAreas}
            className="max-width color-waiting-area-bg color-waiting-area-bg-hover color-white mrrnull"
          >
            <Icon name="arrow right" />
            {APP.LANGUAGE.ViewWaitingArea.Title}
          </Button>
          <div className="waiting-area-quick-view">
            <WaitingAreaPage
              isInQuicKView={true}
              loggedInUserHandler={props.loggedInUserHandler}
              zoom={1}
              noHeader={true}
            />
          </div>
        </div>
      ) : (
        ''
      )}
      {props.userHasMeetingRooms ? (
        <div className="pdlxxs pdrxxs mrbxs quick-view-tile">
          <Button
            icon
            labelPosition="right"
            onClick={goToMeetingRooms}
            className="max-width color-meeting-room-bg color-meeting-room-bg-hover color-white mrrnull"
          >
            <Icon name="arrow right" />
            {APP.LANGUAGE.ViewMeetingRoom.Title}
          </Button>
          <div className="meeting-room-quick-view">
            <MeetingRoomCallPage
              zoom={1}
              noHeader={true}
              noRightMenu={true}
              isMobileView={props.isMobileView}
              goToMeetingRooms={goToMeetingRooms}
            />
          </div>
        </div>
      ) : (
        ''
      )}
      <div>
        {props.canSeeEntityAdminPage ? (
          <div className="pdlxxs pdrxxs mrbxs quick-view-button ">
            <div className="report-quickView-button">
              <Button
                icon
                labelPosition="right"
                onClick={goToOrg}
                className="ui icon right labeled button max-width color-organisational-unit-bg color-organisational-unit-hover mrrnull"
              >
                <Icon name="arrow right" className="color-white" />
                <span className="color-white" style={{ fontSize: '0.9rem' }}>
                  {APP.LANGUAGE.Menu.EntityAdmin}
                </span>
              </Button>
            </div>
          </div>
        ) : (
          ''
        )}
        {props.userHasAdminRights ? (
          <div className="pdlxxs pdrxxs mrbxs quick-view-button ">
            <div className="report-quickView-button">
              <Button
                icon
                labelPosition="right"
                onClick={goToUsers}
                className="ui icon right labeled button max-width color-organisational-unit-bg color-organisational-unit-hover mrrnull"
              >
                <Icon name="arrow right" className="color-white" />
                <span className="color-white" style={{ fontSize: '0.9rem' }}>
                  {APP.LANGUAGE.Menu.Users}
                </span>
              </Button>
            </div>
          </div>
        ) : props.isMobileView ? (
          ''
        ) : (
          <div className="pdlxxs pdrxxs mrbxs quick-view-button" />
        )}
      </div>
      <div>
        {props.userHasReports ? (
          <div className="pdlxxs pdrxxs mrbxs quick-view-button ">
            <div className="report-quickView-button">
              <Button
                icon
                labelPosition="right"
                onClick={goToReports}
                className="ui icon right labeled button max-width  color-reports-bg  mrrnull"
              >
                <Icon name="arrow right" className="color-white" />
                <span className="color-white">Reports</span>
              </Button>
            </div>
          </div>
        ) : (
          ''
        )}
        {props.canAccessResourceCentre ? (
          <div className="pdlxxs pdrxxs mrbxs quick-view-button ">
            <div className="report-quickView-button">
              <Button
                icon
                labelPosition="right"
                onClick={goToResourceCentre}
                className="ui icon right labeled button max-width  color-reports-bg  no-hover-when-click mrrnull"
              >
                <Icon name="external" className="color-white" />
                <span className="color-white">Resource Centre</span>
              </Button>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      {!window.hideUnfinishedItems ? (
        <div className="org-units-quick-view ">
          <button
            type="button"
            onClick={goToOrg}
            className="ui button  right labeled icon color-organisational-unit-bg color-organisational-unit-bg-highlight  color-white  center-text max-width"
          >
            <span className="big-org-name">{APP.LANGUAGE.ViewAllOrgUnit.Title}</span>

            <i className=" arrow right icon  pdlsss wdtpxxl fr  " />
          </button>
          {/*<i className=" sitemap  icon large "></i>*/}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
export default ViewQuickViewCenterPanel;
